<template>
  <div>
        <vue-progress-bar></vue-progress-bar>
        <router-view></router-view>
  </div>
</template>


<script>

  export default {
    created () {
      this.$Progress.start()
      this.$router.beforeEach((to, from, next) => {
        if (to.meta.progress !== undefined) {
          let meta = to.meta.progress
          this.$Progress.parseMeta(meta)
        }
        this.$Progress.start()
        next()
      })
    },
    methods : {
      moment () {
        return window.moment()
      },
    }
  }
  
</script>